/**
 * Shared card chrome + section label for the DQ Workbench tabs.
 *
 * Per the design language: white card, 0.5px tertiary (divider) border, lg
 * radius; section labels are teal, uppercase, letter-tracked. Lived twice
 * (Overview + Trending) before this; one home keeps the tabs visually
 * identical and the look one edit away.
 */
import React from 'react'
import { Typography } from '@mui/material'

import { poolwerxColors } from '../../../../theme/colors'

/** Card container sx - spread onto a MUI <Card sx={...}>. */
export const cardChrome = {
  bgcolor: 'background.paper',
  border: '0.5px solid',
  borderColor: 'divider',
  borderRadius: 3,
} as const

/** Uppercase teal section label that heads each card / region. */
export const SectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography
    variant="caption"
    sx={{
      display: 'block',
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      fontWeight: 700,
      color: poolwerxColors.teal,
      mb: 1.5,
    }}
  >
    {children}
  </Typography>
)
